import { render, staticRenderFns } from "./column-charts.vue?vue&type=template&id=5f482679&"
import script from "./column-charts.vue?vue&type=script&lang=js&"
export * from "./column-charts.vue?vue&type=script&lang=js&"
import style0 from "./column-charts.vue?vue&type=style&index=0&id=5f482679&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports